import { Color, FONT_FAMILY } from "../../ontego-ui";
import { Menu, MenuItem, styled } from '@mui/material';

const Styled = {};

Styled.MenuItem = styled(MenuItem)(() => ({
    height: 36,
    fontFamily: FONT_FAMILY.PLUS_JAKARTA_SANS_REGULAR,
    fontSize: 12,
    color: Color.neutral[900],
    cursor: "pointer",
    display: "flex",
    overflow: "visible",
    "& a": {
        color: Color.neutral[900]
    },
    "&:hover": {
        backgroundColor: Color.neutral[100]
    }
}));

Styled.MenuItemCheckIcon = styled("div")(() => ({
    minWidth: 0,
    marginTop: 4,
    marginRight: 8
}));

Styled.MenuItemText = styled("div")(() => ({
    alignItems: "center",
    display: "flex",
}));

Styled.Menu = styled(Menu)(() => ({
    overflow: "visible",
    borderRadius: 0,
    boxShadow: "0px 2px 29px 0px rgba(3, 3, 3, 0.15)",

    "& .MuiMenu-list": {
        padding: 0,
    }
}));

export default Styled;
